<script>
  import { onMount } from 'svelte';
  import { me, RefreshMe, GetToken } from "@frontend/user";
  import { push } from "svelte-spa-router";
  import { translate, currentLanguage } from "../Translator";

  let userData;
  let loading = true;

  onMount(async () => {
    // Verificar autenticación primero
    if (!$me) {
      push("/user/Login");
      return;
    }

    console.log('UserPerfil montado - Usuario autenticado');
    try {
      await RefreshMe();
      loading = false;
    } catch (error) {
      console.error('Error al obtener datos del usuario:', error);
      loading = false;
    }
  });

  $: {
    userData = $me;
    if (userData) {
      console.log('Información del usuario actualizada:', {
        id: userData.Id,
        email: userData.Email,
        role: userData.Role,
        firstName: userData.FirstName,
        lastName: userData.LastName,
        Reference: userData.Reference,
        group: userData.Group
      });
    }
  }
</script>

<div class="perfil-container">
  <div class="perfil-card">
      <h2>{$translate('User Profile')}</h2>
          {#if loading}
            <p class="loading">Loading Information...</p>
          {:else if userData}
              <dl class="info-list">
                  <div class="info-grupo">
                      <dt>{$translate('First Name')}</dt>
                      <dd>{userData.FirstName || ''} </dd>
                  </div>
                  <div class="info-grupo">
                     <dt>{$translate('Last Name')}</dt>
                    <dd> {userData.LastName || ''}</dd>
                </div>
                  <div class="info-grupo">
                      <dt>{$translate('E-mail')}</dt>
                      <dd>{userData.Email || 'Not available'}</dd>
                  </div>
                  <div class="info-grupo">
                      <dt>{$translate('Phone Number')}</dt>
                      <dd>{userData.PhoneNumber || 'Not available'}</dd>
                  </div>
                  <div class="info-grupo">
                      <dt> {$translate('Role')}</dt>
                      <dd>{userData.Role || 'Not available'}</dd>
                  </div>
                  <div class="info-grupo">
                      <dt>{$translate('Country')}</dt>
                      <dd>{userData.CountryCode || 'Not available'}</dd>
                  </div>
                  <div class="info-grupo">
                      <dt>{$translate('Currency Code')}</dt>
                      <dd>{userData.CurrencyCode || 'Not available'}</dd>
                  </div>
                  <div class="info-grupo">
                    <dt> {$translate('Referral')}</dt>
                    <dd>{userData.Reference || 'Not available'}</dd>
                  </div>
              </dl>
          {:else}
              <p class="no-data">No data</p>
          {/if}
  </div>
</div>

<style>
  .perfil-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    min-height: calc(100vh - 4rem);
    background-color: #f8f9fa;
  }

  .perfil-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
    padding: 2.5rem;
    width: 100%;
    max-width: 600px;
    transition: transform 0.2s ease;
  }

  .perfil-card:hover {
    transform: translateY(-2px);
  }

  h2 {
    color: #2d3748;
    text-align: center;
    margin-bottom: 2.5rem;
    font-size: 1.75rem;
    font-weight: 600;
    position: relative;
  }

  h2::after {
    content: '';
    position: absolute;
    bottom: -0.75rem;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 3px;
    background: linear-gradient(90deg, #3182ce, #63b3ed);
    border-radius: 2px;
  }


  .info-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.75rem;
    margin: 0;
  }

  .info-grupo {
    display: grid;
    gap: 0.5rem;
    transition: transform 0.15s ease;
  }

  .info-grupo:hover {
    transform: translateX(4px);
  }

  dt {
    font-weight: 600;
    color: #4a5568;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  dd {
    margin: 0;
    padding: 0.75rem 1rem;
    background: #f7fafc;
    border-radius: 8px;
    color: #2d3748;
    font-size: 1rem;
    border: 1px solid #e2e8f0;
  }

  .no-data {
    text-align: center;
    color: #718096;
    padding: 2rem;
    background: #f7fafc;
    border-radius: 8px;
    font-style: italic;
  }

  .loading {
    text-align: center;
    color: #718096;
    font-style: italic;
    padding: 2rem;
    background: #f7fafc;
    border-radius: 8px;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  }

  @media (max-width: 640px) {
    .perfil-container {
      padding: 1rem;
    }
    
    .perfil-card {
      padding: 1.5rem;
    }
    
    .info-list {
      grid-template-columns: 1fr;
    }
    
    h2 {
      font-size: 1.5rem;
    }
  }
</style>
